import { identify, makeRequest, Service } from 'utils/http';

export async function getUsersTemplatesApi() {
  return makeRequest(Service.getUsersTemplates(await identify()));
}
